import _regeneratorRuntime from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import { __awaiter } from "tslib";
import React, { useRef, useEffect } from "react";
import { useSpring } from "react-spring";
import { Chip } from "../Chip";
import * as S from "./styles";
export function ChipContainer(_ref) {
  var _this = this;

  var e = _ref.count,
      t = _ref.activeChip,
      i = _ref.className,
      r = _ref.isReverse;
  var c = useRef(r ? e - 1 : 0);
  useEffect(function () {
    c.current = t;
  });

  var a = c.current,
      o = function o(e) {
    return 20 * (e + 1) + 4 * (e - 1);
  },
      p = useSpring({
    config: {
      precision: 1e-6
    },
    to: t > a ? function (e) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e({
                  width: o(t + 1) - o(a) - 4 + "px"
                }).catch(function () {}), e({
                  left: 20 * t + 4 * t + .5 + "px",
                  width: "20px",
                  delay: 200
                }).catch(function () {});

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    } : function (e) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e({
                  left: 20 * t + 4 * t + "px",
                  width: o(a + 1) - o(t) - 4 + "px"
                }).catch(function () {}), e({
                  width: "20px",
                  delay: 200
                }).catch(function () {});

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }),
      n = [];

  for (var _t = 0; _t < e; _t++) {
    n.push(React.createElement(Chip, {
      key: _t
    }));
  }

  return React.createElement(S.ChipContainer, {
    isReverse: r,
    className: i
  }, React.createElement(S.ChipWrapper, null, React.createElement(S.ActiveChip, {
    style: p
  }), n));
}
export default ChipContainer;